import React, { useEffect, useState } from "react";
import { ReactComponent as LeftArrow } from "../../../../../assets/arrow-left.svg";
import { ReactComponent as LeftArrowDark } from "../../../../../assets/arrow-left-dark.svg";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useStateContext } from "../../../../../contexts/ThemeContext";
import { useDispatch, useSelector } from "react-redux";
import { resetUser } from "../../../../../redux/slices/block/createYoutubeBlockSlice";
import { gettingLinkList } from "../../../../../redux/slices/gettingLinksList/gettingLinkListSlice";
import { toast } from "react-hot-toast";
import MediaForm from "../forms/MediaForm";
import useFetchBlock from "../../../../../hooks/useFetchBlock";
import ConfirmModal from "../../../../../components/dashboard/modal/Confirm";
import {
  deleteBlock,
  resetDeletBlock,
} from "../../../../../redux/slices/block/deleteBlockSlice";
import {
  resetDividerCard,
  updatingDivider,
} from "../../../../../redux/slices/cards/cardSlice";
import useLocales from "../../../../../hooks/useLocales";
import useSettings from "../../../../../hooks/useSettings";
import SpinnerGiff from "../../../../../assets/spinner.svg";

const EditMediaLink = () => {
  const { darkMode } = useSelector((state) => state.theme);
  const { translate } = useLocales();
  const { themeDirection } = useSettings();
  const baseUrl = process.env.REACT_APP_API_URL;
  const { optionId } = useParams();
  const { setActiveMainPageNav } = useStateContext();
  const { media } = useParams();
  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem("user"));
  const userId = user.userid;
  const userToken = user.token;
  const linkId = localStorage.getItem("linkId");
  const linkListData = {
    userId,
    userToken,
    linkId,
  };
  const navigate = useNavigate();
  useEffect(() => {
    setActiveMainPageNav(true);

    return () => {
      setActiveMainPageNav(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const [subLoader, setSubLoader] = useState(false);

  const userID = JSON.parse(localStorage.getItem("user")).userid;
  const url = baseUrl + "/api/user/getOption/" + userID + "/" + optionId;
  const { data, loading } = useFetchBlock(url);
  const preData = data?.data?.language;
  // https://www.tiktok.com/[^/?]+
  const handleDividerUpdateData = async (data) => {
    console.log("Edit state", data);
    setSubLoader(true);
    const state = {
      coloum_type: media,
      coloum_value: data.coloum_value,
      coloum_name: media,
      optionId: optionId,
      language: preData,
    };
    console.log("state", state, data);
    await dispatch(updatingDivider(state));
    setSubLoader(false);
    fetchingLinksList(); // fetching link list after submiting , so list become refresh
  };

  const fetchingLinksList = () => {
    dispatch(gettingLinkList(linkListData));
  };

  const {
    updatedDividerCard,
    updatedDividerCardSuccess,
    updatedDividerCardLoading,
  } = useSelector((state) => state?.cards?.dividerCard);
  const { status: dividerStatus, message: dividerMsg } = useSelector(
    (state) => state?.cards?.dividerCard?.updatedDividerCard
  );

  useEffect(() => {
    if (dividerStatus === "success" && updatedDividerCardSuccess) {
      toast.success(dividerMsg);
      navigate("/dashboard");
    }
    if (dividerStatus === "failed" && updatedDividerCardSuccess) {
      toast.error(dividerMsg);
    }
    dispatch(resetDividerCard());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updatedDividerCard, updatedDividerCardLoading]);

  const { isYoutubeBlockError, isYoutubeBlockSuccess, isYoutubeBlockLoading } =
    useSelector((state) => state?.youtubeBlock);
  const { status, message } = useSelector(
    (state) => state?.youtubeBlock?.youtubeBlock
  );
  useEffect(() => {
    if (status === "success" && isYoutubeBlockSuccess) {
      toast.success(message);
      navigate("/dashboard");
    }
    if (status === "failed" && isYoutubeBlockSuccess) {
      toast.error(message);
    }
    dispatch(resetUser());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    isYoutubeBlockError,
    isYoutubeBlockSuccess,
    dispatch,
    isYoutubeBlockLoading,
  ]);

  const deleteHandler = async () => {
    const obj = {
      optionId: optionId,
      userId: userId,
    };
    await dispatch(deleteBlock(obj)).then(() => {});
  };
  const {
    DeleteBlock,
    isDeleteBlockError,
    isDeleteBlockSuccess,
    isDeleteBlockLoading,
    isDeleteBlockErrorMsg,
  } = useSelector((state) => state?.deleteBlock);

  useEffect(() => {
    if (DeleteBlock?.data?.status === "success" && isDeleteBlockSuccess) {
      toast.success(DeleteBlock?.data?.message);
      navigate("/dashboard/component");
    }
    if (DeleteBlock?.data?.status === "failed" && isDeleteBlockSuccess) {
      toast.error(DeleteBlock?.data?.message);
    }
    if (isDeleteBlockError) {
      toast.error(isDeleteBlockErrorMsg);
    }
    dispatch(resetDeletBlock());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDeleteBlockLoading, DeleteBlock]);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleDeleteModal = () => {
    deleteHandler();
    setIsModalOpen(false);
  };

  return (
    <>
      <ConfirmModal
        isOpen={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        onConfirm={handleDeleteModal}
        selectedLang={preData}
      />
      {loading && (
        <div
          style={{ zIndex: "999999" }}
          className="fixed inset-0 h-screen bg-[#ffffffa7] pt-5 flex justify-center items-center overflow-hidden"
        >
          <img src={SpinnerGiff} alt="..." />
        </div>
      )}
      <div className="px-6 md:px-0 mt-[37px] md:mt-0 flex items-center justify-between">
        <Link to={"/dashboard/component"}>
          <div className="flex text-body_copy2 items-center cursor-pointer gap-2">
            <div>
              {darkMode ? (
                <LeftArrowDark
                  className={`${
                    themeDirection === "rtl" ? "transform -scale-x-100" : ""
                  }`}
                />
              ) : (
                <LeftArrow
                  className={`${
                    themeDirection === "rtl" ? "transform -scale-x-100" : ""
                  }`}
                />
              )}
            </div>

            <p className="dark:text-color_v1_dark"> {translate("media")} </p>
          </div>
        </Link>
      </div>
      <MediaForm
        updateMediaLink={handleDividerUpdateData}
        isLoading={subLoader}
        preHeaderData={data}
        formType="edit"
        handleDelete={() => setIsModalOpen(true)}
      />
    </>
  );
};

export default EditMediaLink;
